// src/services/system-analytics.ts
import api from "./api";
import {
  SystemHealth,
  SystemAnalytics,
  UserActivityAnalytics,
  SystemPerformance,
  AnalyticsTimeframe,
} from "../types/system-analytics";

export interface SecretaryDashboardStats {
  studentsRegistered: {
    total: number;
    thisMonth: number;
    growth: number;
  };
  paymentsProcessed: {
    total: number;
    thisMonth: number;
    amount: number;
    growth: number;
  };
  receiptsGenerated: {
    total: number;
    thisMonth: number;
    growth: number;
  };
  pendingTasks: {
    newStudents: number;
    pendingPayments: number;
    expiredFees: number;
  };
  recentActivity: Array<{
    type: string;
    icon: string;
    title: string;
    description: string;
    timestamp: string;
    receiptNumber?: string;
  }>;
}

export interface SecretaryDashboardResponse {
  success: boolean;
  data: SecretaryDashboardStats;
}

export const systemAnalyticsService = {
  // Get system health status
  getSystemHealth: async (): Promise<SystemHealth> => {
    const response = await api.get("/system/health");
    return response.data; // api.get returns {success, data}, so we extract data
  },

  // Get comprehensive system analytics
  getSystemAnalytics: async (
    timeframe: AnalyticsTimeframe = "30d"
  ): Promise<SystemAnalytics> => {
    const response = await api.get(`/system/analytics?timeframe=${timeframe}`);
    return response.data; // api.get returns {success, data}, so we extract data
  },

  // Get user activity analytics
  getUserActivityAnalytics: async (
    timeframe: string = "7d"
  ): Promise<UserActivityAnalytics> => {
    const response = await api.get(
      `/system/user-activity?timeframe=${timeframe}`
    );
    return response.data;
  },

  // Get system performance metrics
  getSystemPerformance: async (): Promise<SystemPerformance> => {
    const response = await api.get("/system/performance");
    return response.data;
  },

  // Get secretary dashboard statistics
  getSecretaryDashboardStats: async (): Promise<SecretaryDashboardStats> => {
    const response = await api.get("/system/secretary-dashboard");
    return response.data;
  },
};
